module.exports = __webpack_public_path__ + "static/img/s28.f5ca12e5.png";